import styled from 'styled-components/native';
import { withDefaultTypographyProps } from '@sp/ui/v2/typography/index.shared';

const H5 = styled(withDefaultTypographyProps)`
  font-size: ${(props) => props.theme.FONT_SIZES.V2_H5.DEFAULT}px;
  line-height: ${(props) => props.theme.FONT_SIZES.V2_H5.DEFAULT * 1.5}px;
`;

H5.defaultProps = {
  fontWeight: 'bold',
  fontStyle: 'normal',
};

export default H5;
